import { render } from "./PromotorsPage.vue?vue&type=template&id=74c4017c&ts=true"
import script from "./PromotorsPage.vue?vue&type=script&lang=ts"
export * from "./PromotorsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Promotors/PromotorsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74c4017c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74c4017c', __exports__)) {
    api.reload('74c4017c', __exports__)
  }
  
  module.hot.accept("./PromotorsPage.vue?vue&type=template&id=74c4017c&ts=true", () => {
    api.rerender('74c4017c', render)
  })

}


export default __exports__